var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"join-the-team"}},[_c('navbar',{attrs:{"clickable":"true"}}),_c('div',{attrs:{"id":"sections-area"}},[_c('sxsw-hero')],1),_c('img',{staticClass:"background-fixed-img",attrs:{"src":"/img/startup-bg.jpg","alt":"SPIRITT background"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }